import Translate from '../i18n/Translate'

const ProfesionalAccess = () => {
    return (
        <button className="profesional-access">
            <a href={process.env.REACT_APP_PROFESIONAL_ACCESS_LINK} target="_blank" rel="noopener noreferrer">
                <span>
                    <Translate langkey="header.profesional-access" />
                </span>
            </a>
        </button>
    )
}

export default ProfesionalAccess
